import * as Accordion from "@radix-ui/react-accordion";
import styled, { keyframes } from "styled-components";

// Um valor grande o suficiente para o conteúdo — serve para suavizar o fechamento
const slideDown = keyframes`
  from {
    max-height: 0;
    opacity: 0;
  }
  to {
    max-height: 500px; /* Valor estimado de altura */
    opacity: 1;
  }
`;

const slideUp = keyframes`
  from {
    max-height: 500px; /* Mesmo valor estimado */
    opacity: 1;
  }
  to {
    max-height: 0;
    opacity: 0;
  }
`;

export const StyledAccordion = styled(Accordion.Root)`
    border-radius: 4px;
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const StyledItem = styled(Accordion.Item)<{ open?: boolean }>``;

export const StyledHeader = styled(Accordion.Header)`
    margin: 0;
    display: flex;
`;

export const StyledButton = styled(Accordion.Trigger)`
    width: 100%;
    font-weight: normal;
`;

export const StyledPanel = styled(Accordion.Content)`
    overflow: hidden;
    will-change: max-height, opacity;
    overflow-y: auto;

    &[data-state="open"] {
        animation: ${slideDown} 300ms ease-out forwards;
    }

    &[data-state="closed"] {
        animation: ${slideUp} 200ms ease-in forwards;
    }
`;
